import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { formatCurrency } from '@angular/common';
import { Subject, takeUntil } from 'rxjs';

import { LiferayService } from '../../../services/liferay/liferay.service';
import { UtilitiesService } from '../../../services/utilities/utilities.service';

import { IMessageByScenario, IWebContant } from '../../../services/liferay/liferay.interface';
import { LIFERAY_WEB_CONSTANT } from '../../../utils/liferay.constant';
import { LIFERAY_CONTENT_KEY_PAST_DUE_BA, LIFERAY_CONTENT_KEY_PAST_DUE_CC, PAYMENT_FLOW_PAST_DUE, PAYMENT_TYPE_CREDIT_CARD } from '../../../utils/constants';
import { PaymentService } from '../../../services/payment/payment.service';
import { IPaymentFlow, IPaymentType } from '../../../interfaces/IPayments';
import { DataService } from '../../../services/data/data.service';

@Component({
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrl: './terms-and-conditions.component.scss'
})
export class TermsAndConditionsComponent implements OnInit, OnDestroy {
  @Input() deductibleAmount?: number = 0;
  type: IPaymentType = PAYMENT_TYPE_CREDIT_CARD;
  // setting a default value as paymentech
  // need to check if we need to display a different message in case no option is selected
  cleaner$ = new Subject<void>();
  termsAndConditions: string = '';
  tAndCsDetails: IWebContant<{ messageByScenario: IMessageByScenario[] }> | null = null;
  paymentInitiation: IPaymentFlow | null = null;

  constructor(
    private liferayService: LiferayService,
    private util: UtilitiesService,
    private payment: PaymentService,
    private data: DataService
  ) {}

  ngOnInit(): void {
    this.liferayService.getWebContent(
      LIFERAY_WEB_CONSTANT.paymentTermsAndConditions.type,
      LIFERAY_WEB_CONSTANT.paymentTermsAndConditions.id
    )
    .pipe(takeUntil(this.cleaner$))
    .subscribe({
      next: (data: any) => {
        if (!data) return;
        this.tAndCsDetails = data;
        this.tAndCsDetails && this.type && this.assignTermsAndConditions();
      },
    });

    this.payment.termsAndConditionsToDisplay$
      .pipe(takeUntil(this.cleaner$))
      .subscribe({
        next: (data: IPaymentType|null) => {
          if (!data) return;
          this.type = data;
          this.tAndCsDetails && this.type && this.assignTermsAndConditions();
        },
      });

    this.paymentInitiation = this.data.paymentInitiation$.getValue();
  }

  ngOnDestroy(): void {
    this.cleaner$.next();
    this.cleaner$.complete();
  }

  assignTermsAndConditions(): void {
    const tAndCs = this.getScenario()?.message || '';
    // replace the placeholder with the actual value if available
    let convertedTAndCs = this.deductibleAmount ?
     this.util.convertInnerHtmlWithValues(tAndCs, 'deductibleAmount', formatCurrency(this.deductibleAmount, 'en', '$')) : tAndCs;
    if (this.data.isPlanFFS() && this.data.isPlanFFSSelected$.getValue()) {
      const replacements = {
        'charge on': 'on',
        'deductible amount': 'amount',
        'the technician will not come to my home to perform service': 'no services will be scheduled or provided',
        '72 hours and will not appear on my monthly statement': '72 hours. Only the actual charge will appear on your monthly statement'
      };

      for (const [key, value] of Object.entries(replacements)) {
        convertedTAndCs = this.util.convertInnerHtmlWithValues(convertedTAndCs, key, value);
      }
    }


    // decode the html content to display it as html
    this.termsAndConditions = this.util.setHtmlContent(convertedTAndCs);
  }

  getScenario(): IMessageByScenario | undefined {
    return this.tAndCsDetails?.value?.messageByScenario
    .find((msg: IMessageByScenario) => {
      // for past due
      if (this.paymentInitiation === PAYMENT_FLOW_PAST_DUE) {
        const selectedScenario = (this.type === PAYMENT_TYPE_CREDIT_CARD) ? LIFERAY_CONTENT_KEY_PAST_DUE_CC : LIFERAY_CONTENT_KEY_PAST_DUE_BA;
        return msg.scenario === selectedScenario;
      } else {
        // for other flows for now
        return msg.scenario === this.type.toLowerCase();
      }
    });
  }
}
